import {
  AUTHENTICATING_OUTREACH_REQUEST, AUTHENTICATING_OUTREACH_SUCCEDDED, AUTHENTICATING_OUTREACH_FAILED, 
  UPDATING_OUTREACH_REQUEST, UPDATING_OUTREACH_SUCCEDDED, UPDATING_OUTREACH_FAILED,
} from '../actionTypes.jsx';
import axios from 'axios';

import {
  activatingIntegrationSuccedded, deactivatingIntegrationSuccedded
} from '../integrations.jsx';

const apiUrl = `${process.env.REACT_APP_API_URL}`;

const OUTREACH_BASE_URL = `${apiUrl}/api/2.0/integrations/outreach`;

export function authenticateAccount(code){
  return function (dispatch) {
    dispatch(authenticatingAccount());

    const data = {
      code: code
    }

    return axios({
      method: 'POST',
      url: OUTREACH_BASE_URL,
      params: data
    })
    .then((response) => {
      dispatch(authenticatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(authenticatingAccountFailed(error.errors))
    )
  }
}

function authenticatingAccount(){
  return {
    type: AUTHENTICATING_OUTREACH_REQUEST,
    payload: {}
  }
}

function authenticatingAccountSuccedded(json){
  return {
    type: AUTHENTICATING_OUTREACH_SUCCEDDED,
    payload: json
  }
}

function authenticatingAccountFailed(error){
  return {
    type: AUTHENTICATING_OUTREACH_FAILED,
    payload: error
  }
}


/**
* Update outreach configuration
*/
export function updateConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingConfiguration());

    return axios({
      method: 'PUT',
      url: OUTREACH_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(updatingConfigurationFailed(error.errors))
    })
  }
}

function updatingConfiguration(){
  return {
    type: UPDATING_OUTREACH_REQUEST,
    payload: {}
  }
}

function updatingConfigurationSuccedded(json){
  return {
    type: UPDATING_OUTREACH_SUCCEDDED,
    payload: json
  }
}

function updatingConfigurationFailed(error){
  return {
    type: UPDATING_OUTREACH_FAILED,
    payload: error
  }
}